"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _YesNoData = _interopRequireDefault(require("./components/YesNoData"));

var SEO_KEY = 'seoAudit';
var _default = {
  results: [new _YesNoData.default({
    localizedTextKey: 'results.seo.indexable',
    resultKeyPath: [SEO_KEY, 'isIndexable']
  }), new _YesNoData.default({
    localizedTextKey: 'results.seo.metaDescription',
    resultKeyPath: [SEO_KEY, 'hasMetaDescription']
  }), new _YesNoData.default({
    localizedTextKey: 'results.seo.plugins',
    resultKeyPath: [SEO_KEY, 'usesNoPlugins']
  }), new _YesNoData.default({
    localizedTextKey: 'results.seo.descriptiveLinks',
    resultKeyPath: [SEO_KEY, 'hasDescriptiveLinks']
  })]
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/SeoData.js
// module id = 148
// module chunks = 0